import { Controller } from '@hotwired/stimulus';

import ModuleLoader from '@/modules/module_loader';
import PaymentMethod from '@/modules/payment_method';

export default class extends Controller {
  connect() {
    new PaymentMethod(ModuleLoader.getOptions()).create();
  }
}
